/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 70 kg person needs about 2.45 L before exercise.`)
};

const es_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una persona de 70 kg necesita unos 2,45 L antes de hacer ejercicio.`)
};

const de_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine 70 kg schwere Person benötigt vor dem Training etwa 2,45 L.`)
};

const nl_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iemand van 70 kg heeft ongeveer 2,45 L nodig, exclusief sport.`)
};

const fr_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une personne de 70 kg a besoin d'environ 2,45 L avant l'exercice.`)
};

const it_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una persona di 70 kg ha bisogno di circa 2,45 L prima dell'esercizio.`)
};

const pt_br2_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma pessoa de 70 kg precisa de cerca de 2,45 L antes do exercício.`)
};

const pt_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma pessoa de 70 kg precisa de cerca de 2,45 L antes do exercício.`)
};

const ja_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体重70kgの人は運動前でも約2.45L必要です。`)
};

const zh_water_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一名体重 70 千克的人，在运动前约需 2.45 升水。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_ex1", locale)
	if (locale === "en") return en_water_ex1(inputs)
	if (locale === "es") return es_water_ex1(inputs)
	if (locale === "de") return de_water_ex1(inputs)
	if (locale === "nl") return nl_water_ex1(inputs)
	if (locale === "fr") return fr_water_ex1(inputs)
	if (locale === "it") return it_water_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_water_ex1(inputs)
	if (locale === "pt") return pt_water_ex1(inputs)
	if (locale === "ja") return ja_water_ex1(inputs)
	return zh_water_ex1(inputs)
};